<template>
  <v-dialog
    v-model="$store.state.categories.show"
    z-index="999"
    width="800"
    height="600"
    transition="dialog-bottom-transition"
  >
    <v-card
      flat
      height="600"
      :style="{
        borderBottom: '3px solid #272727',
        borderLeft: '1px solid #272727',
        borderTop: '1px solid #272727',
        borderRight: '3px solid #272727',
        borderRadius: '8px',
      }"
    >
      <div style="position: sticky; top: 0; z-index: 1000">
        <v-sheet
          class="d-flex justify-space-between align-center px-4 py-2"
          color="accent"
          style="
            z-index: 1000;
            font-size: 10pt;
            font-weight: 600;
            border-top-right-radius: 7px;
            border-top-left-radius: 7px;
          "
        >
          {{ category?.name }}

          <div
            v-if="category.status != 'suggested'"
            class="d-flex"
            style="gap: 10px"
          >
            <v-btn
              variant="text"
              @click="$store.dispatch('deleteCategory', category.uid)"
              >Delete</v-btn
            >
            <v-btn
              variant="flat"
              color="button"
              @click="save"
              style="
                border-left: 1px solid #272727;
                border-right: 3px solid #272727;
                border-top: 1px solid #272727;
                border-bottom: 3px solid #272727;
                border-radius: 6px;
              "
              >Save</v-btn
            >
          </div>
        </v-sheet>
      </div>

      <v-divider class="primary"></v-divider>

      <div>
        <v-tabs v-model="tab" grow>
          <v-tab value="schedule">Schedule</v-tab>
          <v-tab value="description">Description</v-tab>

          <v-tab value="sources">Sources</v-tab>
          <v-tab value="template">Template</v-tab>
        </v-tabs>
        <v-divider></v-divider>
        <div>
          <div v-if="tab === 'schedule'">
            <div class="px-4 pt-4">
              <p style="font-size: 10pt; font-weight: 400">
                When should Stix AI Agent post?
              </p>
            </div>
            <div class="px-4 pb-4 d-flex align-center">
              <v-switch
                color="accent"
                class="mr-2"
                hide-details
                v-model="category.active"
              ></v-switch>
              <span style="font-size: 16pt; font-weight: 600">
                <ScheduleDialog :category="category" />
              </span>
            </div>
          </div>

          <div v-if="tab === 'description'" class="pa-4">
            <div style="display: grid; grid-template-columns: 1fr; gap: 25px">
              <div>
                <p style="font-size: 10pt; font-weight: 400" class="mb-4">
                  What is this category about?
                </p>

                <v-textarea
                  v-model="category.description"
                  placeholder="Write a description of this category"
                  rows="6"
                  label="Description"
                  variant="solo"
                  flat
                  hide-details=""
                  bg-color="smokeDark"
                ></v-textarea>
              </div>

              <!-- <div>
                <p class="mt-4" style="font-size: 10pt">Keywords</p>
                <v-chip-group column multiple>
                  <v-chip
                    v-for="(keyword, index) in category.keywords"
                    :key="keyword"
                    color="primary"
                    variant="flat"
                    size="small"
                    closable=""
                    @click:close="category.keywords.splice(index, 1)"
                  >
                    {{ keyword }}
                  </v-chip>
                </v-chip-group>
                <v-text-field
                  v-model="newKeyword"
                  placeholder="Add keyword"
                  variant="solo"
                  flat
                  hide-details=""
                  @keyup.enter="
                    category.keywords.push(newKeyword);
                    newKeyword = '';
                    menu = false;
                  "
                  bg-color="smokeDark"
                >
                  <template v-slot:append-inner>
                    <v-btn
                      variant="text"
                      icon="mdi-plus"
                      size="x-small"
                      @click="
                        category.keywords.push(newKeyword);
                        newKeyword = '';
                        menu = false;
                      "
                    ></v-btn>
                  </template>
                </v-text-field>
              </div> -->
            </div>

            <p class="mt-4" style="font-size: 10pt">Goals</p>

            <div class="">
              <div v-for="(g, index) in category.goals" :key="g" class="my-2">
                <v-chip
                  multi-line
                  closable=""
                  variant="flat"
                  @click:close="category.goals.splice(index, 1)"
                  >{{ g }}</v-chip
                >
              </div>
            </div>
            <v-text-field
              placeholder="Inform audience about ..."
              variant="solo"
              flat
              hide-details=""
              bg-color="smokeDark"
              @keyup.enter="
                category.goals.push(newGoal);
                newGoal = '';
              "
              v-model="newGoal"
            >
              <template v-slot:append-inner>
                <v-btn
                  variant="text"
                  icon="mdi-plus"
                  size="x-small"
                  @click="
                    category.goals.push(newGoal);
                    newGoal = '';
                  "
                ></v-btn>
              </template>
            </v-text-field>
          </div>

          <div v-if="tab === 'sources'">
            <div class="px-4 pt-4 mb-4">
              <p style="font-size: 10pt; font-weight: 400">
                Add sources to help Stix AI Agent find new post ideas.
              </p>
            </div>

            <div class="px-4">
              <v-data-table
                hide-default-header
                hide-default-footer
                item-key="name"
                class="bg-smokeDark"
                :items="sources"
                no-data-text="No sources found"
                :headers="[
                  { text: 'Name', value: 'name' },
                  { text: 'URL', value: 'url' },
                  { text: 'Actions', value: 'actions' },
                ]"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn
                    variant="text"
                    icon="mdi-delete"
                    size="x-small"
                    @click="$store.dispatch('deleteSource', item)"
                  ></v-btn>
                </template>
              </v-data-table>
            </div>
            <v-divider></v-divider>
            <div
              class="pa-4"
              style="
                display: grid;
                grid-template-columns: 1fr 1fr 60px;
                gap: 10px;
              "
            >
              <v-text-field
                v-model="newSourceName"
                placeholder="Add source name"
                variant="solo"
                flat
                hide-details=""
                bg-color="smokeDark"
              ></v-text-field>
              <v-text-field
                v-model="newSource"
                placeholder="Add source URL (Without www.)"
                variant="solo"
                flat
                hide-details=""
                bg-color="smokeDark"
                @keyup.enter="
                  $store.dispatch('saveSource', {
                    url: newSource,
                    name: newSourceName,
                    last_fetch: null,
                    category: category.uid,
                  });
                  newSource = '';
                "
              >
              </v-text-field>
              <v-btn
                height="60"
                variant="flat"
                color="accent"
                :disabled="!newSource || !newSourceName"
                @click="
                  $store.dispatch('saveSource', {
                    url: newSource,
                    name: newSourceName,
                    last_fetch: null,
                    category: category.uid,
                  });
                  newSource = '';
                "
                ><v-icon>mdi-plus</v-icon></v-btn
              >
            </div>
          </div>

          <div v-if="tab === 'template'">
            <div class="px-4 pt-4">
              <p
                style="font-size: 10pt; font-weight: 400; width: 600px"
                class="mb-4"
              >
                Select a template to use for this category. This template can be
                used to generate images for posts in this category. Define the
                elements that will be used in the template.
              </p>
              <div
                v-if="category.template"
                style="
                  display: grid;
                  grid-template-columns: 300px 1fr;
                  gap: 10px;
                "
              >
                <div>
                  <v-img
                    :src="
                      media.find((m) => m.uid === category.template)
                        ?.thumbnail ||
                      media.find((m) => m.uid === category.template)?.src
                    "
                    width="300"
                    cover
                  ></v-img>
                  <v-btn
                    variant="text"
                    size="small"
                    class="mt-2"
                    prepend-icon="mdi-delete"
                    @click="category.template = null"
                    >Change template</v-btn
                  >
                </div>
                <div>
                  <v-combobox
                    v-model="category.template_elements"
                    variant="solo"
                    flat
                    label="Add element"
                    hide-details=""
                    bg-color="smokeDark"
                    multiple
                    chips
                    closable
                    @click:close="category.template_elements.splice(index, 1)"
                  ></v-combobox>
                </div>
              </div>
              <div
                v-else
                class="d-flex flex-wrap"
                style="gap: 10px; height: 420px; overflow: scroll"
              >
                <div
                  v-for="m in media"
                  :key="m.uid"
                  style="border-radius: 6px; overflow: hidden"
                  @click="category.template = m.uid"
                  class="post-card"
                >
                  <v-img
                    :src="m.thumbnail || m.src"
                    width="100"
                    height="100"
                    cover
                  ></v-img>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "@/firebase";
import ScheduleDialog from "@/components/scheduler/ScheduleDialog.vue";

export default {
  name: "SocialCategory",
  components: { ScheduleDialog },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      sources: (state) =>
        state.sources.sources?.[state.categories.category.uid] || [],
      schedules: (state) => state.schedules.schedules,
      accounts: (state) => state.accounts.accounts,
      posts: (state) => state.posts.posts,
      show: (state) => state.categories.show,
      media: (state) => state.media.media,
    }),
    category: {
      get() {
        return this.$store.state.categories.category;
      },
      set(value) {
        this.$store.commit("setCategory", value);
      },
    },
  },
  data() {
    return {
      unsub: null,
      tab: "schedule",
      newSource: "",
      newSourceName: "",
      days: [
        { text: "Monday", value: 1 },
        { text: "Tuesday", value: 2 },
        { text: "Wednesday", value: 3 },
        { text: "Thursday", value: 4 },
        { text: "Friday", value: 5 },
        { text: "Saturday", value: 6 },
        { text: "Sunday", value: 7 },
      ],
      newKeyword: "",
      menu: false,
      newGoal: "",
      newUrl: "",
      newIdea: "",
    };
  },

  methods: {
    async save() {
      let cat = { ...this.category };
      delete cat.schedule;
      await updateDoc(
        doc(
          db,
          "workspaces",
          this.userProfile.workspace,
          "categories",
          this.category.uid,
        ),
        cat,
      );
      this.$store.commit("setCategoryShow", false);
      this.$store.commit("setNotification", {
        show: true,
        text: "Category saved!",
        type: "primary",
        icon: "mdi-check",
      });
    },

    findSchedule(schedule) {
      return this.schedules.find((s) => s.uid === schedule) || null;
    },
    getDayNames(dayOfWeek) {
      if (!dayOfWeek) return "";
      const dayArray = Array.isArray(dayOfWeek) ? dayOfWeek : [dayOfWeek];
      const dayNames = dayArray
        .map((dayValue) => {
          const day = this.days.find((d) => d.value === dayValue);
          return day ? day.text : "";
        })
        .filter((name) => name);

      if (dayNames.length === 0) return "";
      if (dayNames.length === 1) return dayNames[0];
      if (dayNames.length === 2) return dayNames.join(" and ");
      return (
        dayNames.slice(0, -1).join(", ") +
        " and " +
        dayNames[dayNames.length - 1]
      );
    },
  },
};
</script>

<style scoped>
.post-card {
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease;
}

.post-card:hover {
  transform: translateY(-2px);
}
</style>
